var React = require('react');

function S2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"S2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M42,33.24l12.66-31A29.65,29.65,0,0,0,18,44.84h0A29.52,29.52,0,0,0,32.24,57.1L42,33.24Q40.77,30.87,42,33.24Z","fill":"#e5c83d","key":0}),React.createElement("path",{"d":"M41.87,70.69a29.68,29.68,0,0,0,2.94-41.87L22.4,48.28h0L0,67.75a29.68,29.68,0,0,0,41.87,2.94Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

S2.defaultProps = {"viewBox":"0 0 54.64 77.96"};

module.exports = S2;

S2.default = S2;
